module.exports = __webpack_public_path__ + "static/media/nis_w.64123571.svg";